module.exports = __webpack_public_path__ + "static/media/selfie.ce64416f.png";